export default "__VITE_ASSET__DTykE6UB__"